import { AsyncPipe, NgIf } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormArray, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DropdownPosition, NgSelectModule } from "@ng-select/ng-select";
import { Observable } from "rxjs";
import { ModalComponent } from "../../../components/layout/modal/modal.component";
import { SelectOption } from "../../../models/option";
import { FormControlElement } from "../../models/form-control-element";
import { IsRequiredPipe } from "../../pipes/is-required.pipe";
import { HorizontalWrapperComponent } from "../horizontal-wrapper/horizontal-wrapper.component";
import { SelectComponent } from "../select/select.component";
import { ValidatorComponent } from "../validator/validator.component";

@Component({
  selector: "app-multi-select",
  templateUrl: "./multi-select.component.html",
  styleUrls: ["./multi-select.component.scss"],
  standalone: true,
  imports: [
    HorizontalWrapperComponent,
    NgIf,
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule,
    ValidatorComponent,
    IsRequiredPipe,
    AsyncPipe,
    ModalComponent,
  ],
})
export class MultiSelectComponent extends FormControlElement implements OnInit, OnChanges {
  /**
   * @deprecated TODO: remove after refactor
   */
  @Input() isNew = false;
  /**
   * @deprectad use FormControl
   */
  @Input() formArray!: FormArray; //samen met idPropertyName kunnen de selectedIds gevuld worden.
  /**
   * @deprecated Unused
   */
  @Input() type: string = "";
  @Input() col3: boolean = false;
  @Input() alignRight: boolean = false;
  @Input() marginBottom: boolean = true; // indien false: geen mb-3 (bv. in tabelrij)
  @Input() inTable: boolean = false; // compacte weergave in een tabel; schakelt mb-3 uit

  @Input() modal: boolean = false; // toon modal met meer info
  @Input() modalTitle: string = "Meer info";
  @Input() modalInfo!: HTMLDivElement;
  @ViewChild("content") content!: ElementRef;
  @ViewChild(SelectComponent) select!: SelectComponent;

  @Input() options!: Observable<any[]>; // opties van de dropdown
  /**
   * @deprecated Use observable options
   */
  @Input() options$: SelectOption[] = []; // opties van de dropdown

  @Input() idPropertyName: string = "";
  @Input() labelProperty = "name";
  @Input() valueProperty = "id";

  @Input() label: string = "";
  @Input() min: number = 0; // minimum aantal opties te kiezen TODO: does not work atm
  @Input() max: number = 99; // maximum aantal opties te kiezen TODO: does not fully work atm
  @Input() minMessage: string | null = null; // custom foutboodschap bij te weinig items
  @Input() maxMessage: string | null = null; // custom foutboodschap bij te veel items
  @Input() hideSelected: boolean = true; // verberg de geselecteerde items in de dropdown
  /**
   * @deprecated use control.disabled
   */
  @Input() disabled: boolean = false;
  /**
   * @deprecated
   */
  @Input() selectedIds: (string | number)[] = []; // de geselecteerde opties

  /**
   * @deprecated Is this still necessarry?
   */
  @Output() optionAdded = new EventEmitter<SelectOption>(); // functie om de keuze te bewaren
  /**
   * @deprecated Is this still necessary?
   */
  @Output() optionDeleted = new EventEmitter<{ id: any }>(); // functie om de keuze te verwijderen

  @Input() dropdownPosition: DropdownPosition = "auto";

  @Input() appendTo: string = "";

  constructor(private modalService: NgbModal) {
    super();
  }

  ngOnInit(): void {
    this.updateOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Changes");
    if (changes["options"]) {
      let options = changes["options"];
      let currentOptions: SelectOption[] = options.currentValue;
      let previousOptions: SelectOption[] = options.previousValue;
      if (options.currentValue != options.previousValue) {
        this.updateOptions();
      }
    }
    this.loadIn();
  }
  /**
   * @deprecated
   */
  updateOptions() {
    if (this.options instanceof Observable) {
      this.options.subscribe((options: SelectOption[]) => {
        this.options$ = options.map((x) => {
          return { id: x.id, name: x.name, disabled: x.disabled };
        });
        this.loadIn();
      });
    } else {
      this.options$ = this.options;
      this.loadIn();
    }
  }
  /**
   * @deprecated
   */
  loadIn() {
    if (this.formArray && this.idPropertyName) {
      this.selectedIds = [];
      this.formArray.controls
        .map((x) => x.get(this.idPropertyName)?.value)
        .forEach((id: string) => {
          this.selectedIds.push(id);
        });
    } else {
      this.selectedIds = this.selectedIds;
    }
  }

  open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      size: "lg",
    });
  }

  selectClicked() {
    if (!this.maxMessage) this.maxMessage = "Je mag maximaal " + this.max + " items kiezen.";
  }

  onRemove(event: any) {
    if (this.optionDeleted) this.optionDeleted.emit({ id: event.id });
  }

  /**
   * ng-select vuurt bij het "alles wissen"-kruisje enkel (clear), niet (remove) per item.
   * Daarom emitten we hier optionDeleted voor elke geselecteerde werkgroep, zodat de
   * parent zijn bestaande removeWorkGroup-logica per item draait en de FormArray leegmaakt.
   */
  onClear() {
    if (!this.formArray || !this.idPropertyName) return;
    const ids = this.formArray.controls.map((x) => x.get(this.idPropertyName)?.value);
    ids.forEach((id) => this.optionDeleted.emit({ id }));
  }

  onAdd(event: any) {
    if (this.optionAdded) this.optionAdded.emit(event);
  }
}
